// extracted by mini-css-extract-plugin
export default {"link":"fO-z","disabled":"gO-z"};